import { getPosition, isSizeSelected } from 'product/findinstore';
import { newModalFromSelector, ModalShowHide } from '../components/modal';
import Map from '../components/map';
import StoreHours from 'storeLocator/storeHours';
import IntimissimiStoreHours from '../storeLocator/storeHours';
import { woosmapInitFindInStore, woosmapInitUPS, woosmapListenerForModalClose } from 'woosmap';
import { applyRendering } from '../util/render';
import DispoHelpers from '../checkout/dispoHelpers';

export class IntimissimiFindInStore {
    constructor () {
        this.coordinates = {};
        this.isGeolocalized = false;
        this.wasMapInitialized = false;
        this.elementSelector = '#findinstore';
        this.radiusSelector = 'input[name="fis-radius"]';
        this.querySelector = 'input[name="query"]';
        this.isCheckAvailability = true;
        this.btnSelector = '.js-find-in-store-btn';
        if ($('meta[http-equiv=content-language]').attr('content') === 'ja-JP') {
            this.minCharSearch = 2;
        } else {
            this.minCharSearch = 3;
        }
    }

    run (isCheckAvailability = true) {
        // Define elements from DOM
        this.$element = $(this.elementSelector);
        this.geocodingApiKey = $('[data-geocoding-apikey]').data('geocoding-apikey');
        this.countryCode = $('.findinstore[data-country-code]').data('country-code');
        this.url = $(this.btnSelector).data('url');

        // Create Modal and attach event listeners to the interface
        this.modal = new ModalShowHide(this.elementSelector);
        this.addEventListeners();

        if (!isCheckAvailability || $('.page').data('action').indexOf('Cart-Show') > -1) {
            this.isCheckAvailability = false;
        }
        this.selectSize();
        const $pickupPointElement = $('#pickupPointData');
        if ($pickupPointElement) {
            // Checkout with pickup point method
            this.pickupPointUrl = $('#pickupPointData').data('url');
            this.btnSelectorPickupPoint = '.pickup-point-btn'; // button for find pickup point
            this.addEventListenersPickupPoint();
        }

        this.woosmapListener();
        woosmapListenerForModalClose();

        // Manage updated modal available only in cart or checkout
        this.isCartOrCheckout = $('#findinstoreResultCheckoutTemplate').length > 0;
        if (this.isCartOrCheckout) {
            this.observeViewMore();
        }
        this.addBrandListeners();
        this.addInfoWindowEventListeners();
        this.observeViewMore();
        if (!this.isCheckAvailability) {
            // Only used in pickup in store
            // this.getNearbyStores();
        }
    }
    scrollToMapDesktop () {
        const $map = this.$element.find('#map');
        const $wrapper = $map.closest('.findinstore-wrapper');
        $map.show();

        $wrapper.animate({
            scrollTop: $wrapper.get(0).scrollHeight
        });
    }
    addEventListeners () {
        var _self = this;
        // Add button event to launch find-in-store
        $('body').on('click', this.btnSelector, (e) => {
            if (isSizeSelected()) {
                if (this.sizeModal && this.sizeModal.modal) {
                    this.sizeModal.close();
                }
                $('.persButtonPdpPers').hide();
                $('.findinstore-data-container').data('type', 'Pickup');
                $(e.currentTarget).hasClass('dispo-is-not-available') ? $('.findinstore-data-container').data('is-bopis-modal', true) : null;
                $(e.currentTarget).hasClass('dispo-is-not-available') ? $('.find-in-store-wrapper').removeClass('hide') : null;
                this.launch();
            } else {
                // If no size is selected, enable attribute selectors, open modal to choose one
                this.sizeModal = newModalFromSelector('fis-select-size', false, ['fis-select-size-modal']);
                $(this.sizeModal.modalBox).find('.size-selector').removeAttr('disabled');
                $(this.sizeModal.modalBox).find('.size-selector').removeClass('notifyMe');
                $(this.sizeModal.modalBox).find('.notifyIcon').remove();
                this.sizeModal.open();
                $(this.sizeModal.modalBox).on('click', '.modal__closeIcon', (e) => {
                    this.sizeModal.close();
                    this.sizeModal.destroy();
                });
            }
            $('.input-text-woosmap').prop('id', 'input-text-woosmap-findinstore');
            woosmapInitFindInStore();
            $('body').trigger('product:moreInfoToggle', 'find_in_store');
            e.preventDefault();
        });

        $('body').on('click', '#findinstore-usecurrentposition', (e) => {
            this.$element.find('.localities-empty-button').trigger('click');
            this.detectLocation();
            e.preventDefault();
            e.stopPropagation();
        });

        $('body').on('click', '.js-choose-store', (e) => {
            var storeEvent = e;
            this.selectStore(storeEvent);
            this.modal.hide();
        });

        // Handle Geocoding request (look for city, zipcode, ..)
        $('body').on('submit', '#findinstore-form', (e) => {
            e.preventDefault();
        });

        // Handle Geocoding update event
        $('body').on('geocode:update', this.$element, (e, res) => {
            if (res.success) {
                // Set active coordinates according to Google Geocoding's response
                this.coordinates.lat = res.data.lat;
                this.coordinates.long = res.data.long;
                // Update map with current coordinates
                this.map.updateCoordinates(this.coordinates);
                this.getStores();
            } else {
                // Log failure to the console as warning
                console.warn('Geocoding via Google failed: ' + res.status);
                $.spinner().stop();
            }

            // Remove loading state from geocoding button
            $('#findinstore-form').find('input[type="button"]').removeAttr('disabled');
        });

        // Handle typing in search field
        $('body').on('keyup', this.querySelector, (e) => {
            const $searchButton = $(this.querySelector).parent().find('[type="submit"]');

            if ($(this.querySelector).val().length < this.minCharSearch) {
                $searchButton.attr('disabled', 'disabled');
            } else {
                $searchButton.removeAttr('disabled');
            }
        });

        // Handle Radius button change
        $('body').on('change', this.radiusSelector, (e) => {
            this.getStores();
            e.preventDefault();
        });

        // Handle "show on map" click
        $('body').on('click', '.fis-show-on-map', (e) => {
            const coords = {
                lat: Number($(e.currentTarget).data('coords').split(',')[0]),
                lng: Number($(e.currentTarget).data('coords').split(',')[1])
            };

            this.map.centerMapOnCoordinates(coords);
            if ($('.page-checkout').length > 0 || $('.cart-page').length > 0) {
                this.scrollToMapDesktop();
            }
            this.scrollToMap();
            e.preventDefault();
            e.stopPropagation();
        });

        // Add button event to launch find-in-store
        let selector = this.btnSelector + '.js-select-store,' + this.btnSelector + '.js-change-store';
        $('body').on('click', selector, (e) => {
            if (isSizeSelected()) {
                if (this.sizeModal && this.sizeModal.modal) {
                    this.sizeModal.close();
                }
                $('.persButtonPdpPers').hide();
                $('.findinstore-wrapper').data('type', 'Pickup');
                this.launch();
            } else {
                // If no size is selected, enable attribute selectors, open modal to choose one
                this.sizeModal = newModalFromSelector('fis-select-size', false, ['fis-select-size-modal']);
                $(this.sizeModal.modalBox).find('.size-selector').removeAttr('disabled');
                $(this.sizeModal.modalBox).find('.size-selector').removeClass('notifyMe');
                $(this.sizeModal.modalBox).find('.notifyIcon').remove();
                this.sizeModal.open();
                $(this.sizeModal.modalBox).find('.alertNotify').hide();
                $(this.sizeModal.modalBox).on('click', '.modal__closeIcon', (e) => {
                    this.sizeModal.close();
                    this.sizeModal.destroy();
                });
            }
            $('.input-text-woosmap').prop('id', 'input-text-woosmap-findinstore');
            $('.js-switchFindBopis').removeClass('active');
            woosmapInitFindInStore();
            $('body').trigger('product:moreInfoToggle', 'find_in_store');
            e.preventDefault();
        });

        $('body').on('click', '#findinstore-usecurrentposition', (e) => {
            this.$element.find('.localities-empty-button').trigger('click');
            this.detectLocation();
            e.preventDefault();
            e.stopPropagation();
            $('body').trigger('checkout:geolocationSucceeded');
        });

        $('body').on('focusin', '.localities-input-wrapper', (e) => {
            $(e.currentTarget).closest('.form-item').find('.form-control-label').css('opacity', '1');
        });
        $('body').on('focusout', '.localities-input-wrapper', (e) => {
            $(e.currentTarget).closest('.form-item').find('.form-control-label').css('opacity', '0');
        });

        $('.storeLocatorNearbyList').on('click', function () {
            $('.result').show();
            $('.map-canvas').hide();
            $('.storeLocatorNearbyMap').addClass('change-opacity');
            $('.view-more-button-cell').addClass('view-more-map-close').removeClass('view-more-map-open');
            $('.storeLocatorNearbyList').removeClass('change-opacity');
        });

        $('.storeLocatorNearbyMap').on('click', function () {
            $('.map-canvas').show().addClass('map-canvas-map-open');
            $('.result').hide();
            $('.view-more-button-cell').addClass('view-more-map-open').removeClass('view-more-map-close');
            $('.storeLocatorNearbyList').addClass('change-opacity');
            $('.storeLocatorNearbyMap').removeClass('change-opacity');
        });

        // Handle Geocoding request (look for city, zipcode, ..)
        $('body').on('submit', '#findinstore-form', (e) => {
            // TODO: Instead of google geocode, center map on coordinates
            /*
            const query = $(e.currentTarget).find(this.querySelector).val();
            // Lock geocoding button
            $(e.currentTarget).find('input[type="button"]').attr('disabled', 'disabled');
            this.map.geocode(query, this.countryCode, this.$element);
            */
            e.preventDefault();
        });

        // Handle Geocoding update event
        $('body').on('geocode:update', this.$element, (e, res) => {
            if (res.success) {
                // Set active coordinates according to Google Geocoding's response
                this.coordinates.lat = res.data.lat;
                this.coordinates.long = res.data.long;
                // Update map with current coordinates
                this.map.updateCoordinates(this.coordinates);
                this.getStores();
            } else {
                // Log failure to the console as warning
                console.warn('Geocoding via Google failed: ' + res.status);
                $.spinner().stop();
            }

            // Remove loading state from geocoding button
            $('#findinstore-form').find('input[type="button"]').removeAttr('disabled');
        });

        // Handle typing in search field
        $('body').on('keyup', this.querySelector, (e) => {
            const $searchButton = $(this.querySelector).parent().find('[type="submit"]');

            if ($(this.querySelector).val().length < this.minCharSearch) {
                $searchButton.attr('disabled', 'disabled');
            } else {
                $searchButton.removeAttr('disabled');
            }
        });

        // Handle Radius button change
        $('body').on('change', this.radiusSelector, (e) => {
            var buttonSelected = $('.findinstore-wrapper').data('type');
            if (buttonSelected === 'PUP') {
                this.getStoresPickupPoint();
            } else {
                this.getStores();
            }
            e.preventDefault();
        });

        // Handle "show on map" click
        $('body').on('click', '.fis-show-on-map', (e) => {
            $(window).on('resize', function (e) {
                checkScreenSize();
            });

            if ($('.cc-orderDetails-orderReturnModal').length === 0) {
                checkScreenSize();
            }

            function checkScreenSize () {
                if (!Foundation.MediaQuery.atLeast('large')) {
                    $('.map-canvas').show().addClass('map-canvas-map-open');
                    $('.result').hide();
                    $('.view-more-button-cell').addClass('view-more-map-open').removeClass('view-more-map-close');
                    $('.storeLocatorNearbyList').addClass('change-opacity');
                    $('.storeLocatorNearbyMap').removeClass('change-opacity');
                }
            }
            const coords = {
                lat: Number($(e.currentTarget).data('coords').split(',')[0]),
                lng: Number($(e.currentTarget).data('coords').split(',')[1])
            };

            this.map.centerMapOnCoordinates(coords);
            this.scrollToMap();
            e.preventDefault();
            e.stopPropagation();
        });
    }

    launch () {
        // Only initialize Google's map once and on-demand
        if (!this.wasMapInitialized) {
            this.initMap();
        }

        // If no coordinates are set, attempt to locate user and get stores
        if (!this.hasCoordinates()) {
            this.detectLocation();
        } else {
            // Otherwise, just get the stores with the current information
            this.getStores();
        }

        if (this.sizeModal && this.sizeModal.modal) {
            this.sizeModal.close();
            this.sizeModal.destroy();
        }
        this.modal.show();
    }

    detectLocationPickupPoint () {
        getPosition()
            .then((position) => {
                this.isGeolocalized = true;
                // Set active coordinates according to the browser's navigator
                this.coordinates.lat = position.coords.latitude;
                this.coordinates.long = position.coords.longitude;

                this.map.updateCoordinates(this.coordinates);
                this.getStoresPickupPoint();
                const query = this.coordinates;
                this.map.geocode(query);
            })
            .catch((err) => {
                // User geolocation not available, log error to the console as warning
                console.warn(err.message);
                $('#findinstore-usecurrentposition').addClass('disabled');
            });
    }

    selectSize () {
        var _self = this;
        // Handle click on select size modal buttons
        $('body').on('click', '.fis-select-size-modal button.size-selector', (e) => {
            const sizeValue = $(e.currentTarget).data('attr-value');
            $(e.currentTarget).closest('ul').find('button').not(e.currentTarget).removeClass('selected');
            $(e.currentTarget).addClass('selected');

            $('.fis-select-size-modal .find-in-store-size-select-btn').removeAttr('disabled');
            $(this.btnSelector).data('size-value', sizeValue);
            e.stopPropagation();
        });

        $('body').on('click', '.find-in-store-size-select-btn', (e) => {
            if ($('.fis-select-size-modal .find-in-store-size-select-btn').data('size-value') !== '') {
                this.launch();
            }
            e.stopPropagation();
        });

        $('body').off('click', '.js-switchFindBopis');
        $('body').on('click', '.js-switchFindBopis', function () {
            var switchBopis = $('.js-switchFindBopis');
            var selected = false;
            if (!switchBopis.hasClass('active')) {
                selected = true;
            }
            _self.searchForStores(true, selected);
            switchBopis.toggleClass('active');
        });
    }

    launchPickupPoint () {
        // Only initialize Google's map once and on-demand
        if (!this.wasMapInitialized) {
            this.initMap();
        }

        // If no coordinates are set, attempt to locate user and get stores
        if (!this.hasCoordinates()) {
            this.detectLocationPickupPoint();
        } else {
            // Otherwise, just get the stores with the current information
            this.getStoresPickupPoint();
        }

        if (this.sizeModal && this.sizeModal.modal) {
            this.sizeModal.close();
            this.sizeModal.destroy();
        }
        this.modal.show();
    }

    addEventListenersPickupPoint () {
        // Add button event to launch pickup-point
        $('body').on('click', this.btnSelectorPickupPoint, (e) => {
            $('.findinstore-data-container').data('type', 'PUP').addClass('cc-pup');
            this.launchPickupPoint();
            $('.input-text-woosmap').prop('id', 'input-text-woosmap-ups');
            woosmapInitUPS();
            e.preventDefault();
        });

        $('body').on('click', '.js-choose-point', (e) => {
            const selectedStoreId = e.currentTarget.dataset.storeId;

            const storeName = $(e.target).closest('.result').find('.store-name');
            const storeAddress1 = $(e.target).closest('.result').find('.js-store-address-row1');
            const storeCity = $(e.target).closest('.result').find('.js-store-city');
            const storePostalCode = $(e.target).closest('.result').find('.js-store-postal-code');

            const selectedStoreName = storeName.text();
            const address1 = storeAddress1.text();
            const city = storeCity.text();
            const postalCode = storePostalCode.text();

            $('.selectedPickupPointRecap .js-point-name').html(selectedStoreName);
            $('.selectedPickupPointRecap .js-point-address1').html(address1);
            $('.selectedPickupPointRecap .js-point-city').html(city);
            $('.selectedPickupPointRecap .js-point-postal-code').html(postalCode);

            $('.js-select-point').hide();
            $('.js-change-point').show();

            $('.selectedPickupPointRecap').show();

            const data = {
                number: selectedStoreId,
                name: selectedStoreName,
                address1: address1,
                city: city,
                postalCode: postalCode
            };

            $('body').trigger('pickupPoint:selectedPoint', data);
            this.modal.hide();
            $('.next-step-button').find('.submit-shipping').prop('disabled', false);
        });

        $('body').on('click', '.show-on-map-from-outside-popup-pickup-point', (e) => {
            this.launchPickupPoint();
        });

        $('body').off('click', '#findinstore-usecurrentposition');

        $('body').on('click', '#findinstore-usecurrentposition', (e) => {
            this.$element.find('.localities-empty-button').trigger('click');
            var buttonSelected = $('.findinstore-data-container').data('type');

            if (buttonSelected === 'PUP') {
                this.detectLocationPickupPoint();
            } else {
                this.detectLocation();
            }
            e.preventDefault();
            e.stopPropagation();
            var sizeList = [];
            var skuList = [];
            $('.analytics.checkout.checkout-product').each(
                function (el, ind) {
                    skuList.push($(ind).data('item_sfcc'));
                }
            );

            let skuListPdp = skuList.join(',');
            $('body').trigger('storeLocator:searchWithZipCodeGeoCheckout', { size: null, sku: skuListPdp });
        });

        // For avoid findinstore listener
        $('body').off('geocode:update');

        // Handle Geocoding update event
        $('body').on('geocode:update', this.$element, (e, res) => {
            if (res.success) {
                // Set active coordinates according to Google Geocoding's response
                this.coordinates.lat = res.data.lat;
                this.coordinates.long = res.data.long;
                // Update map with current coordinates
                this.map.updateCoordinates(this.coordinates);
                var buttonSelected = $('.findinstore-data-container').data('type');
                if (buttonSelected === 'PUP') {
                    this.getStoresPickupPoint();
                } else {
                    this.getStores();
                }
            } else {
                // Log failure to the console as warning
                console.warn('Geocoding via Google failed: ' + res.status);
            }

            // Remove loading state from geocoding button
            $('#findinstore-form').find('input[type="button"]').removeAttr('disabled');
        });

        $('body').on('click', '.js-choose-point-infowindow', (e) => {
            const selectedStoreId = e.target.dataset.storeId;

            const $result = $('#fis-results').find('.result').filter(`[data-store-id="${selectedStoreId}"]`);

            if (!$result.length) {
                return;
            }

            const storeName = $result.find('.store-name');
            const storeAddress1 = $result.find('.js-store-address-row1');
            const storeCity = $result.find('.js-store-city');
            const storePostalCode = $result.find('.js-store-postal-code');

            const selectedStoreName = storeName.html();
            const address1 = storeAddress1.html();
            const city = storeCity.html();
            const postalCode = storePostalCode.html();

            $('.selectedPickupPointRecap .js-point-name').html(selectedStoreName);
            $('.selectedPickupPointRecap .js-point-address1').html(address1);
            $('.selectedPickupPointRecap .js-point-city').html(city);
            $('.selectedPickupPointRecap .js-point-postal-code').html(postalCode);

            $('.js-select-point').hide();
            $('.js-change-point').show();

            $('.selectedPickupPointRecap').show();

            const data = {
                number: selectedStoreId,
                name: selectedStoreName,
                address1: address1,
                city: city,
                postalCode: postalCode
            };

            $('body').trigger('pickupPoint:selectedPoint', data);
            this.modal.hide();
        });
    }

    renderResultOutsidePopupPickupPoint (data, resources, isSelected = false) {
        let buttonFragment = `<p class="small strong ${data.availability === 'high' ? 'text-brand-green' : 'text-alert'} text-right">${data.availabilityLabel}</p>`;
        if (this.isCheckAvailability === false) {
            buttonFragment = `<button type="button" class="button button-primary js-choose-point font-size-12" data-store-id="${data.store.ID}">${resources.select}</button>`;
        }
        return `
            <div class="grid-x pickup-point-result result ${isSelected ? 'result--selected' : ''}" data-store-id="${data.store.ID}">
                <div class="cell medium-1 small-1">
                    <i class="fas fa-lg fa-map-marker-alt marker-icon" aria-hidden="true" role="presentation"></i>
                </div>
                <div class="cell medium-3 small-7 js-store-row">
                    <div class="store-details">
                        <span class="font-size-14">
                            <span class="store-name strong">${data.store.name}</span>
                            <br />
                            <span class="js-store-address-row1">${data.store.address1}</span>
                            <br />
                            <span class="js-store-city">${data.store.city}</span>, <span class="js-store-postal-code">${data.store.postalCode}</span>
                        </span>
                    </div>
                </div>
                <div class="cell medium-2 small-2 align-self-middle text-center">
                    <span class="js-store-distance">${data.distance || ''}</span>
                </div>
                <div class="cell medium-2 align-self-middle hide-for-small-only">
                    <a target="_blank" class="uppercase font-normal force-hover show-on-map-from-outside-popup-pickup-point" data-coords="${data.store.latitude},${data.store.longitude}">${resources.showOnMap}</a>
                </div>
                <div class="cell medium-2 text-right align-self-middle hide-for-small-only">
                    ${buttonFragment}
                </div>
                <div class="cell small-10 show-for-small-only text-center">
                    <div class="spacer medium"></div>
                    <span><a target="_blank" class="uppercase font-normal force-hover show-on-map-from-outside-popup-pickup-point" data-coords="${data.store.latitude},${data.store.longitude}">${resources.showOnMap}</a></span>&emsp;
                    <span>${buttonFragment}</span>
                </div>
            </div>`;
    }

    addBrandListeners () {
        $('body').on('findinstore:selectedStore', (e, selectedStoreId) => {
            $('#nearby-stores, #prompt-not-found, .js-select-store, .js-select-modal-store').hide();
            $('.next-step-button').find('.submit-shipping').prop('disabled', false);
        });

        $('body').on('click', '.fis-show-on-map', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const coords = {
                lat: Number($(e.currentTarget).data('coords').split(',')[0]),
                lng: Number($(e.currentTarget).data('coords').split(',')[1])
            };

            // this.launch();

            this.map.centerMapOnCoordinates(coords);
            this.scrollToMap();
        });

        $('body').on('click', '.js-store-row', (e) => {
            const $storeRow = $(e.currentTarget);
            const $otherStoreRows = $('#nearby-stores .js-store-row').not($storeRow);

            $otherStoreRows.each((i, el) => {
                $(el).siblings('.js-store-details').hide();
            });

            $storeRow.siblings('.js-store-details').show();
        });

        const data = this;
        $('[data-accordion=pickupInStore]:not(.js-disabled)').click(function () {
            data.loadThreeLocationsLogic();
            $('#nearby-stores').addClass('hidden');
        });

        $('[data-accordion=pickupPoint]:not(.js-disabled)').click(function () {
            data.loadThreeLocationsLogicPickupPoint();
            $('#nearby-stores').addClass('hidden');
        });

        $('body').on('click', '.show-on-map-from-outside-popup', function (e) {
            data.launch();
        });
    }

    searchForNearbyStores (resetStep) {
        const $nearbyStores = $('#nearby-stores');
        const url = $nearbyStores.data('url');

        let dataContainer = $('.findinstore-data-container');
        let rad = 1;
        if (resetStep) {
            rad = parseInt(dataContainer.data('base-step'));
        } else {
            rad = parseInt(dataContainer.attr('data-current-step'));
        }

        $.spinner().start();
        getPosition()
            .then((position) => {
                this.isGeolocalized = true;
                // Set active coordinates according to the browser's navigator
                this.coordinates.lat = position.coords.latitude;
                this.coordinates.long = position.coords.longitude;

                const payload = {
                    lat: this.coordinates.lat,
                    lon: this.coordinates.long,
                    rad: rad,
                    pid: undefined,
                    color: undefined,
                    size: undefined
                };

                if (url) {
                    $.ajax({
                        url: url,
                        type: 'get',
                        data: payload,
                        dataType: 'json',
                        success: (res) => {
                            if (!res.error) {
                                this.handleStoresResults(res.stores, res.resources, res, true);
                                $('.js-switchFindBopis').removeClass('active');
                            }
                        },
                        complete: () => {
                            $.spinner().stop();
                        }
                    });
                }
            })
            .catch((err) => {
                // User geolocation not available, log error to the console as warning
                console.warn(err.message);
                $.spinner().stop();
                $('#findinstore-usecurrentposition').addClass('disabled');
            });
    }

    detectLocation () {
        getPosition()
            .then((position) => {
                this.isGeolocalized = true;
                // Set active coordinates according to the browser's navigator
                this.coordinates.lat = position.coords.latitude;
                this.coordinates.long = position.coords.longitude;

                this.map.updateCoordinates(this.coordinates);
                this.getStores();
                const query = this.coordinates;
                this.map.geocode(query);
                if ($('.page').data('action') === 'Order-Details') {
                    $('body').trigger('analytics:refundFindYourStore', { 'action': 'geolocation' });
                } else {
                    $('body').trigger('storeLocator:geolocationSucceeded', { action: 'shipping_method' });
                }
            })
            .catch((err) => {
                // User geolocation not available, log error to the console as warning
                console.warn(err.message);
                $('#findinstore-usecurrentposition').addClass('disabled');
            });
    }

    searchForStores (resetStep, filterBopis) {
        if (!this.hasCoordinates()) {
            return;
        }
        const self = this;

        // Data to send with the request
        const pid = $('body').find('[data-master-pid]').data('master-pid');
        const color = $('[data-attr="color"] .swatch-value.selected').data('attr-value');

        let dataContainer = $('.findinstore-data-container');
        let rad = 1;
        if (resetStep) {
            rad = parseInt(dataContainer.data('base-step'));
        } else {
            rad = parseInt(dataContainer.attr('data-current-step'));
        }

        let size;

        if (isSizeSelected()) {
            size = $('[data-attr="size"] input:checked').data('attr-value');
        } else {
            size = $(this.btnSelector).data('size-value');
        }

        const payload = {
            lat: this.coordinates.lat,
            lon: this.coordinates.long,
            rad: rad,
            pid,
            color,
            size,
            filterBopis: filterBopis,
            currentHour: (new Date()).getHours()
        };

        $.spinner().start();

        if (this.url) {
            $.ajax({
                url: this.url,
                type: 'get',
                data: payload,
                dataType: 'json',
                success: function (res) {
                    if (!res.error) {
                        self.handleStoresResults(res.stores, res.resources, res, false);
                        if (!filterBopis) {
                            $('.js-switchFindBopis').removeClass('active');
                        }
                        var element = $($('.result:not(.is-bopis)')[0]);
                        var elementBopis = $($('.result.is-bopis')[0]);
                        if ($('.shipping-method-selected .js-shipping-method').attr('data-visiblePickableText') === undefined) {
                            var visiblePickableText = '';
                            $($('.cc-textS.cc-findInStoreResultsCheckout-bopis')[0]).children().each(function () {
                                if (!$(this).hasClass('hidden')) {
                                    visiblePickableText += $(this).text().trim() + ' ';
                                }
                            });
                            $('.shipping-method-selected .js-shipping-method').attr('data-visiblePickableText', visiblePickableText);
                        }
                        element = element.find('.cc-findInStoreResultsCheckout-bopis:not(.time-details-bopis)');
                        elementBopis = elementBopis.find('.cc-findInStoreResultsCheckout-bopis');
                        var firstPart = element.find('.today-bopis').text();
                        var firstPartBopis = elementBopis.find('.today-bopis').text();
                        if (!element.find('.tomorrow-bopis').hasClass('hidden')) {
                            firstPart = element.find('.tomorrow-bopis').text();
                        }
                        if (!elementBopis.find('.tomorrow-bopis').hasClass('hidden')) {
                            firstPartBopis = elementBopis.find('.tomorrow-bopis').text();
                        }
                        var secondPart = element.find('.js-store-dispo-info-collection').text();
                        var secondPartBopis = elementBopis.find('.js-store-dispo-info-collection').text();
                        var noBopisLabel = firstPart + ' ' + secondPart;
                        var bopisLabel = firstPartBopis + ' ' + secondPartBopis;
                        var completeNoDispoArrivalLabel = $('.completeNoDispoArrivalLabel').val();
                        $('#personalizationRemovedNoBopisLabel').val(noBopisLabel);
                        $('#personalizationRemovedBopisLabel').val(bopisLabel);
                        $('#completeNoDispoArrivalLabel').val(completeNoDispoArrivalLabel);

                    }
                }
            });
        }
    }

    searchForStoresPickupPoint (resetStep) {
        if (!this.hasCoordinates()) {
            return;
        }
        const self = this;

        // Data to send with the request

        let dataContainer = $('.findinstore-data-container');
        let rad = 1;
        if (resetStep) {
            rad = parseInt(dataContainer.data('base-step-pickup-point'));
        } else {
            rad = dataContainer.attr('data-next-step-pickup-point') ? parseInt(dataContainer.attr('data-next-step-pickup-point')) : parseInt(dataContainer.data('base-step-pickup-point'));
        }

        const payload = {
            lat: this.coordinates.lat,
            lon: this.coordinates.long,
            rad: rad,
            pid: undefined,
            color: undefined,
            size: undefined
        };

        $.spinner().start();

        if (this.pickupPointUrl) {
            $.ajax({
                url: this.pickupPointUrl,
                type: 'get',
                data: payload,
                dataType: 'json',
                success: function (res) {
                    $.spinner().stop();
                    if (!res.error) {
                        if (res.stores.length < 5 && res.showMoreEnabled) {
                            let dataContainer = $('.findinstore-data-container');
                            dataContainer.attr('data-current-step-pickup-point', res.currentStep);
                            dataContainer.attr('data-next-step-pickup-point', res.nextStep);
                            self.searchForStoresPickupPoint(false);
                        } else {
                            self.handleStoresResultsPickupPoint(res.stores, res.resources, res, false);
                        }
                    }
                }
            });
        }
    }

    // from outside popup
    getStoresFromOutsidePopup (e, findInStoreIntimissimiData) {
        if (!this.hasCoordinates()) {
            return;
        }
        const self = this;

        // Data to send with the request
        const pid = $('body').find('[data-master-pid]').data('master-pid');
        const color = $('[data-attr="color"] .swatch-value.selected').data('attr-value');
        const rad = this.$element
            .find(this.radiusSelector)
            .filter(':checked')
            .val();

        const radiusValue = this.$element
            .find(this.radiusSelector)
            .filter(':checked')
            .siblings('.radio-label')
            .text().trim();

        let size;

        if (isSizeSelected()) {
            size = $('[data-attr="size"] input:checked').data('attr-value');
        } else {
            size = $(this.btnSelector).data('size-value');
        }

        const payload = {
            lat: this.coordinates.lat,
            lon: this.coordinates.long,
            pid,
            color,
            rad,
            size
        };

        $.spinner().start();

        if (this.url) {
            $.ajax({
                url: this.url,
                type: 'get',
                data: payload,
                dataType: 'json',
                success: function (res) {
                    if (!res.error) {
                        self.handleStoresResultsFromOutsidePopup(res.stores, res.resources, radiusValue, e, findInStoreIntimissimiData);
                    }
                }
            });
        }
    }

    getNearbyStores () {
        this.searchForNearbyStores(true);
    }

    initMap () {
        const _actualInitMap = () => {
            // Create new Google Map with target and initial center on IP-detected geolocation
            let initialCoordinates = [0, 0];
            const initialCoordinatesString = $('.findinstore[data-geolocation]').data('geolocation');

            if (initialCoordinatesString.length) {
                initialCoordinates = initialCoordinatesString.split(',');
            }

            this.map = new Map(this.$element.find('#map'), [Number(initialCoordinates[0]), Number(initialCoordinates[1])]);
            this.map.init();
            this.wasMapInitialized = true;
        };
        if (typeof google === 'undefined') {
            const apiKey = $('.findinstore[data-maps-api-key]').data('maps-api-key');
            window.googleMapsApiLazyValue = loadGoogleMapsApi(apiKey);
            window.googleMapsApiLazyValue()
                .then((maps) => { _actualInitMap(); });
        } else {
            _actualInitMap();
        }
    }

    addInfoWindowEventListeners () {
        $('body').on('click', '.js-choose-store-infowindow', (e) => {
            const selectedStoreId = e.target.dataset.storeId;
            const $result = $('#fis-results').find('.result').filter(`[data-store-id="${selectedStoreId}"]`);
            const dispoArrivalLabel = $result.find('.time-details-bopis').get(0) ? $result.find('.time-details-bopis').get(0).innerText : '';
            const isBopisStore = $result.hasClass('is-bopis');

            if (!$result.length) {
                return;
            }

            const storeName = $result.find('.store-name');
            const storeAddress = $result.find('.js-store-address-row1');
            const storeCity = $result.find('.js-store-city');
            const storePhone = $result.find('.js-store-phone');

            $('.js-store-name').html(storeName.html());
            $('.js-store-address1').html(storeAddress.html());
            $('.js-store-address2').html(storeCity.html());
            $('.js-store-phone').attr('href', storePhone.attr('href'));
            $('.js-store-phone').html(storePhone.html());

            $('.js-select-store').hide();
            $('.js-change-store').show();

            $('.selectedStoreRecap').show();

            $result.hasClass('is-bopis') ? $('.store-info').addClass('is-bopis') : $('.store-info').removeClass('is-bopis');
            isBopisStore ? $('.store-info').addClass('is-bopis') : $('.store-info').removeClass('is-bopis');
            isBopisStore ? $('.shipping-method-selected .estimated-delivery').text(dispoArrivalLabel) : null;
            isBopisStore ? $('.shipping-method-selected .estimated-delivery').addClass('free-shipping-message') : $('.shipping-method-selected .estimated-delivery').removeClass('free-shipping-message');

            $('body').trigger('findinstore:selectedStore', { selectedStoreId, storeName: storeName.text() });
            this.modal.hide();
            $('body').trigger(document.exitFullscreen());
        });
    }

    hasCoordinates () {
        return this.coordinates.lat && this.coordinates.long;
    }

    getStores () {
        this.searchForStores(true);
    }

    getStoresPickupPoint () {
        this.searchForStoresPickupPoint(true);
    }

    selectStore (e) {
        const selectedStoreId = e.target.dataset.storeId;

        const storeName = $(e.target).closest('.result').find('.store-name');
        const storeAddress = $(e.target).closest('.result').find('.js-store-address-row1');
        const storeCity = $(e.target).closest('.result').find('.js-store-city');
        const storePhone = $(e.target).closest('.result').find('.js-store-phone');
        const storeInfoCollection = $(e.target).closest('.result').find('.js-store-info-collection');
        const isBopisStore = $(e.target).closest('.result').hasClass('is-bopis');
        const isBopisModal = $('.findinstore-data-container').data('is-bopis-modal') === true;
        const dispoArrival = $(e.target).closest('.result').find('.js-store-dispo-info-collection');
        const dispoArrivalLabel = $(e.target).closest('.result').find('.time-details-bopis').get(0) ? $(e.target).closest('.result').find('.time-details-bopis').first().find('span:not(.hidden)').toArray().map(function (el) { 
            return el.innerText;
        }).join(' ') : '';
        const noDispoArrivalLabel = $('.shipping-method-selected .js-shipping-method').attr('data-visiblePickableText');

        $('.js-store-name').html(storeName.html());
        $('.js-store-address1').html(storeAddress.html());
        $('.js-store-address2').html(storeCity.html());
        $('.js-store-phone').attr('href', storePhone.attr('href'));
        $('.js-store-info-collection').html(storeInfoCollection.html());

        $('.js-store-dispo-info-collection').html(dispoArrival.html());
        isBopisStore ? $('.store-info').addClass('is-bopis') : $('.store-info').removeClass('is-bopis');
        isBopisStore ? $('.shipping-method-selected .estimated-delivery').text(dispoArrivalLabel) : $('.shipping-method-selected .estimated-delivery').text($('.noDispoArrivalInterval').val());
        isBopisStore ? $('.shipping-method-selected .estimated-delivery').addClass('free-shipping-message text-infiniteInventory') : $('.shipping-method-selected .estimated-delivery').removeClass('free-shipping-message text-infiniteInventory');
        isBopisStore ? $('.cc-checkBopisAvailability-checkoutSummary').removeClass('hidden') : $('.cc-checkBopisAvailability-checkoutSummary').addClass('hidden');

        $('.js-select-store').hide();
        $('.js-change-store').show();

        $('.selectedStoreRecap').show();

        $('body').trigger('findinstore:selectedStore', { selectedStoreId, storeName: storeName.text() });
        isBopisModal ? $('.js-expressButtonContinue').trigger('click') : null;
        isBopisModal ? $('.checkout-btn').trigger('click') : null;
    }

    observeViewMore () {
        var _self = this;
        $('.findinstore-data-container').on('click', '.view-more-button', function (e) {
            if ($(e.currentTarget).hasClass('instorepickup')) {
                _self.searchForNearbyStores(false);
            } else if ($(e.currentTarget).hasClass('pickuppoint')) {
                _self.searchForStoresPickupPoint(false);
            } else {
                _self.searchForStores(false, ($('.js-switchFindBopis').length > 0 && $('.js-switchFindBopis').hasClass('active')));
            }
        });
    }

    handleStoresResults (stores, resources, result, fromCheckout) {
        // Manage cart and checkout modal with template
        const isCartOrCheckout = $('#findinstoreResultCheckoutTemplate').length > 0;
        // Fit bounds to markers
        if (this.map) {
            this.map.updateMarkers(stores, resources, isCartOrCheckout);
        }

        let dataContainer = $('.findinstore-data-container');
        dataContainer.attr('data-current-step', result.currentStep);

        const $target = fromCheckout ? $('#nearby-stores') : $('#fis-results');
        $target.empty();

        if ($target.length) {
            if (isCartOrCheckout) {
                $('.map-canvas').removeClass('hide');
            }
            let html = `<p class="cc-storesResults-summary strong">${resources.summary.replace('RADIUS', result.currentStep)}</p>`;
            const selectedStoreId = $('#storeId').val();

            if (stores.length) {
                stores.map((store, labelIndex) => {
                    const isSelected = store.store.ID === selectedStoreId;
                    let labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
                    let label = '';
                    let increment = Math.floor(labelIndex >= labels.length ? labelIndex / labels.length : 0);
                    let index = Math.floor(labelIndex > labels.length ? (labelIndex - Math.floor(labelIndex / labels.length).toFixed(0) * labels.length) : labelIndex);
                    label = labels[index % labels.length] + (increment > 0 ? increment + '' : '');
                    if (fromCheckout) {
                        html += this.renderNearbyResult(store, resources);
                    } else if (isCartOrCheckout) {
                        var storeBlock = '';
                        if (DispoHelpers.isDispoActive()) {
                            storeBlock = this.renderStoreBlock(store);
                        }
                        html += this.renderResultWithTemplate(store, label, isSelected, storeBlock);
                    } else {
                        html += this.renderResult(store, resources, isSelected, label);
                    }
                });
            }

            if (result.showMoreEnabled) {
                html += `<div class="spacer medium"></div><div class="grid-x grid-margin-x text-center"><div class="cell"><button class="button button--secondary view-more-button ${fromCheckout ? 'instorepickup' : ''} ">${dataContainer.data('view-more-label')}</button><div></div>`;
            }

            $target.html(html);

            if (DispoHelpers.isDispoActive()) {
                DispoHelpers.handleDispoStores();
            }
        }

        $(this.modal.$el).spinner().stop();

        StoreHours.run();
        if (DispoHelpers.isDispoActive()) {
            IntimissimiStoreHours.run();
        }

        if (result.isPersonalizedBasket) {
            $('.personalization-bopis-message').removeClass('hide');
        }
        $('.find-in-store-wrapper').removeClass('hide');
    }

    handleStoresResultsPickupPoint (stores, resources, result, fromCheckout) {
        $('.map-canvas').removeClass('hide');

        // Fit bounds to markers
        if (this.map) {
            this.map.updateMarkers(stores, resources);
        }

        let dataContainer = $('.findinstore-data-container');
        dataContainer.attr('data-current-step-pickup-point', result.currentStep);
        dataContainer.attr('data-next-step-pickup-point', result.nextStep);

        const $target = fromCheckout ? $('#nearby-stores') : $('#fis-results');
        $target.empty();

        if ($target.length) {
            let html = `<p class="strong">${resources.summary.replace('RADIUS', result.currentStep)}</p>`;
            const selectedStoreId = $('#pickUpPointNumber').val();
            // const selectedStoreName = $('#pickUpPointName').val();

            if (stores.length) {
                stores.map((store, labelIndex) => {
                    let labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
                    let label = '';
                    let increment = Math.floor(labelIndex >= labels.length ? labelIndex / labels.length : 0);
                    let index = Math.floor(labelIndex > labels.length ? (labelIndex - Math.floor(labelIndex / labels.length).toFixed(0) * labels.length) : labelIndex);
                    label = labels[index % labels.length] + (increment > 0 ? increment + '' : '');
                    const isSelected = store.store.ID === selectedStoreId;
                    if (fromCheckout) {
                        html += this.renderNearbyResultPickupPoint(store, resources, label);
                    } else {
                        html += this.renderResultPickupPoint(store, resources, isSelected, label);
                    }
                });
            }

            if (result.showMoreEnabled) {
                html += `<div class="spacer medium"></div><div class="grid-x grid-margin-x text-center"><div class="cell"><button class="button button--secondary view-more-button pickuppoint">${dataContainer.data('view-more-label')}</button><div></div>`;
            }

            $target.html(html);
        }

        $(this.modal.$el).spinner().stop();
    }

    // from outside popup
    handleStoresResultsFromOutsidePopup (stores, resources, radius, e, findInStoreIntimissimiData) {
        // Fit bounds to markers
        this.map.updateMarkers(stores, resources);

        const $target = $('#fis-results');
        $target.empty();

        if ($target.length) {
            let html = `<p class="strong">${resources.summary.replace('RADIUS', radius)}</p>`;

            if (stores.length) {
                stores.map((store) => {
                    html += this.renderResult(store, resources);
                });
            }

            $target.html(html);
        }

        $(this.modal.$el).spinner().stop();

        e.preventDefault();
        e.stopPropagation();
        const coords = {
            lat: Number($(e.currentTarget).data('coords').split(',')[0]),
            lng: Number($(e.currentTarget).data('coords').split(',')[1])
        };

        findInStoreIntimissimiData.map.centerMapOnCoordinates(coords);
        findInStoreIntimissimiData.scrollToMap();
    }

    renderNearbyResult (data, resources) {
        let buttonFragment = `<button type="button" class="button wide js-choose-store no-margin" data-store-id="${data.store.ID}">${resources.select}</button>`;

        return `
            <div class="cell grid-x result" data-store-id="${data.store.ID}">
                <div class="cell shrink">
                    <i class="nearby-stores__icon fas fa-lg fa-map-marker-alt" aria-hidden="true" role="presentation"></i>
                </div>
                <div class="cell auto grid-x js-store-row">
                    <div class="cell small-6 medium-4 store-details">
                        <p>
                            <span class="store-name uppercase strong">${data.store.name}</span>
                        </p>
                        <p>
                            <span class="js-store-address-row1">${data.store.address1}</span>
                            <br>
                            <span class="js-store-city">${data.store.city}, ${data.store.postalCode}</span>
                        </p>
                        ${typeof data.store.phone !== 'undefined' ? '<p><a class="font-normal js-store-phone no-hover no-underline" href="tel:' + data.store.phone + '">' + data.store.phone + '</a></p>' : ''}
                    </div>
                    <div class="cell small-4 medium-1 text-center align-self-middle">
                        <span class="uppercase font-size-12">${data.distance}</span>
                    </div>
                    <div class="cell show-for-medium small-2 text-center align-self-middle">
                        <a target="_blank" class="uppercase fis-nearby-show-on-map font-normal font-size-12 force-hover" data-coords="${data.store.latitude},${data.store.longitude}">${resources.showOnMap}</a>
                    </div>
                    <div class="cell show-for-medium auto align-self-middle text-right">
                        ${buttonFragment}
                    </div>
                </div>
                <div class="cell grid-x js-store-details hide-for-medium" style="display:none">
                    <div class="cell spacer verysmall"></div>
                    <div class="cell small-5 small-offset-1 text-center align-self-middle">
                        <a target="_blank" class="uppercase fis-nearby-show-on-map font-normal font-size-12 force-hover" data-coords="${data.store.latitude},${data.store.longitude}">${resources.showOnMap}</a>
                    </div>
                    <div class="cell small-4 align-self-middle text-right">
                        ${buttonFragment}
                    </div>
                </div>
                <div class="cell spacer"></div>
            </div>`;
    }

    renderResult (data, resources, isSelected = false, label) {
        let buttonFragment = `<p class="small strong ${data.availability === 'high' ? 'text-brand-green' : 'text-alert'} text-right">${data.availabilityLabel}</p>`;
        let storeHoursBlock = '';

        if (this.isCheckAvailability === false) {
            buttonFragment = `<button type="button" class="button button--primary js-choose-store font-size-12 cc-findInStoreModal-selectStoreButton" data-store-id="${data.store.ID}" data-store-name="${data.store.name}">${resources.select}</button>`;
        } else if ('storeHours' in data.store) {
            let storeHours = `
                <span class="store-hours-${data.store.ID}">
                    <span class="store-hours-open hidden">${data.storeOpenLabel}</span>
                    <span class="store-hours-closed hidden">${data.storeClosedLabel}</span>
                </span>
                <span class="store-hours-next-phase">
                    <span class="store-hours-open-until hidden">${data.storeOpenUntilLabel} </span>
                    <span class="store-hours-reopens-at hidden">${data.storeReopensLabel} </span>
                </span>
            `;

            let storeHoursList = data.store.storeHours;
            let storeHoursListLabel = '';

            for (var i = 0; i < storeHoursList.length; i++) {
                storeHoursListLabel += `
                    <li data-name="${storeHoursList[i].name}" data-phases="${storeHoursList[i].hasPhases ? storeHoursList[i].phases : false}" data-first-phase="${storeHoursList[i].firstPhase}">
                        ${storeHoursList[i].label} <span class="float-right">${storeHoursList[i].phases}</span>
                    </li>
                `;
            }

            storeHoursBlock = `
                <a href="#" class="js-toggle-store-hours">
                    ${storeHours}
                    <svg class="toggle-store-hours-dropdown"><use xlink:href="${data.toggleDropdownIcon}" /></svg>
                </a>
                <div class="store-hours-list margin-distance hidden">
                    <ul>
                        ${storeHoursListLabel}
                    </ul>
                </div>
            `;
        }

        return `
            <div class="grid-x result ${isSelected ? 'result--selected' : ''} ${data.store.isBopisStore ? 'is-bopis' : ''}" data-store-id="${data.store.ID}">
                <div class="large-shrink">
                    <i class="fas fa-lg fa-map-marker-alt" aria-hidden="true" role="presentation">
                        <span class="label-count small">${label}</span>
                    </i>
                </div>
                <div class="large-auto small-9 js-store-row">
                    <p class="cc-textS ${data.store.isBopisStore ? 'time-details-bopis mb-2 text-infinite' : 'mb-2'}">
                        <span class="today-bopis">${data.store.pickUpTimeLabel}</span>
                        <span class="tomorrow-bopis hidden">${data.store.tomorrowPickUpTimeLabel}</span>
                        <span class="js-store-dispo-info-collection"></span>
                    </p>
                    <div class="store-details">
                        <p class="cc-findInStoreModal-storeName">
                            <span class="store-name cc-text cc-findInStoreModal-storeName_text">${data.store.name}</span>
                        </p>
                        <p class="distance">
                            <span class="js-store-address-row1">${data.store.address1}</span>
                            <span class="cc-findInStoreModal-marginDistance">${this.isGeolocalized === true ? (data.distance ? data.distance : data.store.distance) : ''}</span>
                        </p>
                        <p>
                            <span class="js-store-city">${data.store.city}, ${data.store.postalCode}</span>
                        </p>
                        ${typeof data.store.phone !== 'undefined' ? '<p><a class="font-normal js-store-phone no-hover no-underline" href="tel:' + data.store.phone + '">' + data.store.phone + '</a></p>' : ''}
                        <p><span class="js-store-info-collection">${data.store.infoCollection ? data.store.infoCollection : ''}</span></p>
                        <div class="store-hours" data-store-id="${data.store.ID}">
                            ${storeHoursBlock}
                        </div>
                    </div>
                    <div class="spacer small"></div>
                    <div class="cell grid-x grid-margin-x cc-findInStoreModal-mapSelectionButtons">
                        <div class="cc-findInStoreModal-showOnMapButton">
                            <a target="_blank" class="fis-show-on-map cc-textS force-hover" data-coords="${data.store.latitude},${data.store.longitude}">${resources.showOnMap}</a>
                        </div>
                        <div class="cell spacer small"></div>
                        <div class="text-right">
                            ${buttonFragment}
                        </div>
                    </div>
                    <div class="spacer"></div>
                </div>
            </div>`;
    }

    renderResultWithTemplate (data, labelIndex, isSelected = false, storeBlock) {
        const storeResultData = {
            isSelected: isSelected ? 'result--selected' : '',
            id: data.store.ID,
            name: data.store.name,
            address1: data.store.address1,
            distance: this.isGeolocalized ? (data.distance ? data.distance : data.store.distance) : '',
            city: data.store.city,
            postalCode: data.store.postalCode,
            infoCollection: data.store.infoCollection,
            lat: data.store.latitude,
            long: data.store.longitude,
            index: labelIndex,
            isBopisEnabled: data.store.isBopisEnabled,
            isBopisStore: data.store.isBopisStore ? 'is-bopis' : '',
            pickUpTimeLabel: data.store.pickUpTimeLabel,
            tomorrowPickUpTimeLabel: data.store.tomorrowPickUpTimeLabel,
            dispoArrival: data.store.dispoArrival,
            isTomorrow: data.store.isTomorrow ? '' : 'hidden',
            isToday: !data.store.isTomorrow ? '' : 'hidden',
            timeDetailsBopis: data.store.isBopisStore ? 'time-details-bopis' : '',
            storeBlock: storeBlock,
            isDispoActive: DispoHelpers.isDispoActive() ? '' : 'hidden'
        };
        return applyRendering('findinstoreResultCheckoutTemplate', storeResultData);
    }

    renderStoreBlock (data) {
        var storeHoursBlock = '';
        if ('storeHours' in data.store) {
            let storeHours = `
                <span class="store-hours-${data.store.ID}">
                    <span class="store-hours-open hidden">${data.storeOpenLabel}</span>
                    <span class="store-hours-closed hidden">${data.storeClosedLabel}</span>
                </span>
                <span class="store-hours-next-phase">
                    <span class="store-hours-open-until hidden">${data.storeOpenUntilLabel} </span>
                    <span class="store-hours-reopens-at hidden">${data.storeReopensLabel} </span>
                </span>
            `;

            let storeHoursList = data.store.storeHours;
            let storeHoursListLabel = '';

            for (var i = 0; i < storeHoursList.length; i++) {
                storeHoursListLabel += `
                    <li data-name="${storeHoursList[i].name}" data-phases="${storeHoursList[i].hasPhases ? storeHoursList[i].phases : false}" data-first-phase="${storeHoursList[i].firstPhase}">
                    <span class="cc-storeResult-container_storeHours_list_days">${storeHoursList[i].label}</span> <span class="cc-storeResult-container_storeHours_list_hours">${storeHoursList[i].phases}</span>
                    </li>
                `;
            }

            storeHoursBlock = `
                <div class="js-store-hours store-hours cc-findInStoreResultsCheckout-storeHours">
                    <a href="#" class="cc-textS js-toggle-store-hours cc-findInStoreResultsCheckout-storeHours-info">
                        ${storeHours}
                        <svg class="toggle-store-hours-dropdown cc-findInStoreResultsCheckout-storeHours-dropdown" aria-hidden="true"><use xlink:href="${data.toggleDropdownIcon}" /></svg>
                    </a>
                    <div class="js-store-hours-list store-hours-list margin-distance cc-findInStoreResultsCheckout-storeHours-infoWindow hidden">
                        <ul>
                            ${storeHoursListLabel}
                        </ul>
                    </div>
                </div>
            `;
        }
        return storeHoursBlock;
    }

    renderNearbyResultPickupPoint (data, resources) {
        let buttonFragment = `<button type="button" class="button wide js-choose-point no-margin" data-store-id="${data.store.ID}">${resources.select}</button>`;

        return `
            <div class="cell grid-x result" data-store-id="${data.store.ID}">
                <div class="cell shrink">
                    <i class="nearby-stores__icon fas fa-lg fa-map-marker-alt" aria-hidden="true" role="presentation"></i>
                </div>
                <div class="cell auto grid-x js-store-row">
                    <div class="cell small-6 medium-4 store-details">
                        <p>
                            <span class="store-name strong">${data.store.name}</span>
                            <br>
                            <span class="js-store-address-row1">${data.store.address1}</span>
                            <br>
                            <span class="js-store-city">${data.store.city}</span>, <span class="js-store-postal-code">${data.store.postalCode}</span>
                        </p>
                        ${typeof data.store.phone !== 'undefined' ? '<p><a class="font-normal js-store-phone no-hover no-underline" href="tel:' + data.store.phone + '">' + data.store.phone + '</a></p>' : ''}
                    </div>
                    <div class="cell small-4 medium-1 text-center align-self-middle">
                        <span class="uppercase font-size-12">${data.distance}</span>
                    </div>
                    <div class="cell show-for-medium small-2 text-center align-self-middle">
                        <a target="_blank" class="uppercase fis-nearby-show-on-map font-normal font-size-12 force-hover" data-coords="${data.store.latitude},${data.store.longitude}">${resources.showOnMap}</a>
                    </div>
                    <div class="cell show-for-medium auto align-self-middle text-right">
                        ${buttonFragment}
                    </div>
                </div>
                <div class="cell grid-x js-store-details hide-for-medium" style="display:none">
                    <div class="cell spacer verysmall"></div>
                    <div class="cell small-5 small-offset-1 text-center align-self-middle">
                        <a target="_blank" class="uppercase fis-nearby-show-on-map font-normal font-size-12 force-hover" data-coords="${data.store.latitude},${data.store.longitude}">${resources.showOnMap}</a>
                    </div>
                    <div class="cell small-4 align-self-middle text-right">
                        ${buttonFragment}
                    </div>
                </div>
                <div class="cell spacer"></div>
            </div>`;
    }

    renderResultPickupPoint (data, resources, isSelected = false, label) {
        let buttonFragment = `<p class="small strong ${data.availability === 'high' ? 'text-brand-green' : 'text-alert'} text-right">${data.availabilityLabel}</p>`;
        if (this.isCheckAvailability === false) {
            buttonFragment = `<button type="button" class="button button-primary js-choose-point js-choose-pickupPointPDB font-size-12" data-store-id="${data.store.ID}">${resources.select}</button>`;
        }

        return `
            <div class="grid-x result ${isSelected ? 'result--selected' : ''}" data-store-id="${data.store.ID}">
                <div class="large-shrink small-1">
                    <i class="fas fa-lg fa-map-marker-alt" aria-hidden="true" role="presentation">
                        <span class="label-count small">${label}</span>
                    </i>
                </div>
                <div class="large-auto small-9 js-store-row">
                    <div class="store-details notranslate">
                        <p class="distance">
                            <span class="store-name strong notranslate">${data.store.name}</span>
                            <span class="margin-distance">${this.isGeolocalized === true ? data.distance : ''}</span>
                        </p>
                        <p>
                            <span class="js-store-address-row1">${data.store.address1}</span>
                        </p>
                        <p>
                            <span class="js-store-city">${data.store.city}</span>, <span class="js-store-postal-code">${data.store.postalCode}</span>
                        </p>
                        ${typeof data.store.phone !== 'undefined' ? '<p><a class="font-normal js-store-phone no-hover no-underline" href="tel:' + data.store.phone + '">' + data.store.phone + '</a></p>' : ''}
                    </div>
                    <div class="cell spacer small"></div>
                    <div class="cell grid-x">
                        <div class="cell small-5 align-self-middle">
                            <a target="_blank" class="uppercase fis-show-on-map font-normal force-hover" data-coords="${data.store.latitude},${data.store.longitude}">${resources.showOnMap}</a>
                        </div>
                        <div class="cell small-5 text-right">
                            ${buttonFragment}
                        </div>
                    </div>
                    <div class="cell spacer"></div>
                </div>
            </div>`;
    }

    loadThreeLocationsLogic () {
        // $('#pickupInStore').hide();

        const data = this;

        let dataContainer = $('.findinstore-data-container');
        let rad = 1;

        rad = parseInt(dataContainer.data('base-step'));

        $.spinner().start();

        getPosition()
            .then((position) => {
                this.isGeolocalized = true;

                const payload = {
                    lat: position.coords.latitude,
                    lon: position.coords.longitude,
                    rad: rad,
                    pid: undefined,
                    color: undefined,
                    size: undefined
                };

                if (data.url) {
                    $.ajax({
                        url: data.url,
                        type: 'get',
                        data: payload,
                        dataType: 'json',
                        success: function (res) {
                            if (!res.error) {
                                data.loadThreeLocationNearToYou(res.stores, res.resources, res, false);
                            }
                        }
                    });
                }
            })
            .catch((err) => {
            // User geolocation not available, log error to the console as warning
                console.warn(err.message);
                $.spinner().stop();
                $('#findinstore-usecurrentposition').addClass('disabled');
            });
    }

    loadThreeLocationNearToYou (stores, resources, result, fromCheckout) {
        let dataContainer = $('.findinstore-data-container');
        dataContainer.attr('data-current-step', result.currentStep);

        const $target = $('#locationsInCheckout');
        $target.empty();

        if ($target.length) {
            let html = ``;
            const selectedStoreId = $('#storeId').val();
            var firstThreeStores = [];

            if (stores.length) {
                for (var i = 0; i < 3; i++) {
                    firstThreeStores.push(stores[i]);
                }
            }

            if (firstThreeStores.length) {
                firstThreeStores.map((store) => {
                    if (store) {
                        const isSelected = store.store.ID === selectedStoreId;
                        html += this.renderResultOutsidePopup(store, resources, isSelected);
                    }
                });
            }

            if (result.showMoreEnabled) {
                html += `<div class="spacer medium"></div><div class="grid-x grid-margin-x text-center"><div class="cell"></div>`;
            }

            $target.html(html);
            $('#locationsInCheckout').parents('.js-shipping-accordion').removeClass('hidden');
        }

        $(this.modal.$el).spinner().stop();
    }

    loadThreeLocationsLogicPickupPoint () {
        // $('#pickupInStore').hide();

        const data = this;

        let dataContainer = $('.findinstore-data-container');
        let rad = 1;

        rad = parseInt(dataContainer.data('base-step-pickup-point'));

        $.spinner().start();

        getPosition()
            .then((position) => {
                this.isGeolocalized = true;

                const payload = { // TODO: Remove comment - used for testing
                    lat: position.coords.latitude,
                    lon: position.coords.longitude,
                    rad: rad,
                    pid: undefined,
                    color: undefined,
                    size: undefined
                };

                if (data.pickupPointUrl) {
                    $.ajax({
                        url: data.pickupPointUrl,
                        type: 'get',
                        data: payload,
                        dataType: 'json',
                        success: function (res) {
                            if (!res.error) {
                                data.loadThreeLocationNearToYouPickupPoint(res.stores, res.resources, res, false);
                            }
                        },
                        error: function () {
                            $.spinner().stop();
                        }
                    });
                }
            })
            .catch((err) => {
            // User geolocation not available, log error to the console as warning
                console.warn(err.message);
                $.spinner().stop();
                $('#findinstore-usecurrentposition').addClass('disabled');
            });

        $.spinner().stop();
    }

    loadThreeLocationNearToYouPickupPoint (stores, resources, result, fromCheckout) {
        let dataContainer = $('.findinstore-data-container');
        dataContainer.attr('data-current-step', result.currentStep);

        const $target = $('#pickupPointLocationsInCheckout');
        $target.empty();

        if ($target.length) {
            let html = ``;
            const selectedStoreId = $('#storeId').val();
            var firstThreeStores = [];

            if (stores.length) {
                for (var i = 0; i < 3; i++) {
                    if (stores[i] && stores[i] !== undefined) {
                        firstThreeStores.push(stores[i]);
                    }
                }
            }

            if (firstThreeStores.length) {
                firstThreeStores.map((store) => {
                    const isSelected = store.store.ID === selectedStoreId;
                    html += this.renderResultOutsidePopupPickupPoint(store, resources, isSelected);
                });
            }

            if (result.showMoreEnabled) {
                html += `<div class="spacer medium"></div><div class="grid-x grid-margin-x text-center"><div class="cell"></div>`;
            }

            $target.html(html);
            $('#pickupPointLocationsInCheckout').parents('.js-shipping-accordion').removeClass('hidden');
        }

        $(this.modal.$el).spinner().stop();
    }

    renderResultOutsidePopup (data, resources, isSelected = false) {
        let buttonFragment = `<p class="small strong ${data.availability === 'high' ? 'text-brand-green' : 'text-alert'} text-right">${data.availabilityLabel}</p>`;
        if (this.isCheckAvailability === false) {
            buttonFragment = `<button type="button" class="button button-primary js-choose-store font-size-12 thin" data-store-id="${data.store.ID}">${resources.select}</button>`;
        }

        // ${typeof data.store.storeHours !== 'undefined' ? '<p>' + data.store.storeHours + '</p>' : ''}
        // ${typeof data.store.phone !== 'undefined' ? '<p><a class="font-normal js-store-phone no-hover no-underline" href="tel:' + data.store.phone + '">' + data.store.phone + '</a></p>' : ''}

        return `
            <div class="grid-x pickup-instore-result result ${isSelected ? 'result--selected' : ''}" data-store-id="${data.store.ID}">
                <div class="cell medium-1 small-1">
                    <i class="fas fa-lg fa-map-marker-alt marker-icon" aria-hidden="true" role="presentation"></i>
                </div>
                <div class="cell medium-3 small-7 js-store-row">
                    <div class="store-details">
                        <span class="font-size-14">
                            <span class="js-store-address-row1 strong">${data.store.address1}</span>
                            <br />
                            <span class="js-store-city">${data.store.city}, ${data.store.postalCode}</span>
                            <br />
                            <span class="js-store-info-collection">${data.store.infoCollection ? data.store.infoCollection : ''}</span>
                            <span class="js-store-dispo-info-collection"></span>
                        </span>
                    </div>
                </div>
                <div class="cell medium-2 small-2 align-self-middle text-center">
                    <span class="js-store-distance">${data.distance || ''}</span>
                </div>
                <div class="cell medium-2 align-self-middle hide-for-small-only">
                    <a target="_blank" class="uppercase font-normal force-hover show-on-map-from-outside-popup" data-coords="${data.store.latitude},${data.store.longitude}">${resources.showOnMap}</a>
                </div>
                <div class="cell medium-2 text-right align-self-middle hide-for-small-only">
                    ${buttonFragment}
                </div>
                <div class="cell small-10 show-for-small-only text-center">
                    <div class="spacer medium"></div>
                    <span><a target="_blank" class="uppercase font-normal force-hover show-on-map-from-outside-popup" data-coords="${data.store.latitude},${data.store.longitude}">${resources.showOnMap}</a></span>&emsp;
                    <span>${buttonFragment}</span>
                </div>
            </div>`;
    }

    scrollToMap () {
        // Show Map and scroll to it
        const $map = this.$element.find('#map');
        const $wrapper = $map.closest('.findinstore-wrapper');
        $map.show();

        $wrapper.animate({
            scrollTop: $wrapper.get(0).scrollHeight
        });
    }

    woosmapListener () {
        var _self = this;

        $('body').on('woosmap:chooseOptionFindInStore', function (e, selection) {
            if (selection.geometry && selection.geometry.location.lat && selection.geometry.location.lng) {
                // Set active coordinates according to Google Geocoding's response
                _self.coordinates.lat = selection.geometry.location.lat;
                _self.coordinates.long = selection.geometry.location.lng;
                // Update map with current coordinates
                _self.map.updateCoordinates(_self.coordinates);
                _self.getStores();
                $('body').trigger('storeLocator:searchWithZipCodeGeoCheckoutCity', { name: selection.name });
                $('.js-switchFindBopis').removeClass('active');
            } else {
                // Log failure to the console as warning
                console.warn('Geocoding via Woosmap failed.');
                $.spinner().stop();
            }
        });

        $('body').on('woosmap:chooseOptionUPS', function (e, selection) {
            if (selection.geometry && selection.geometry.location.lat && selection.geometry.location.lng) {
                // Set active coordinates according to Google Geocoding's response
                _self.coordinates.lat = selection.geometry.location.lat;
                _self.coordinates.long = selection.geometry.location.lng;
                // Update map with current coordinates
                _self.map.updateCoordinates(_self.coordinates);
                _self.getStoresPickupPoint();
                $('body').trigger('storeLocator:searchWithZipCodeGeoCheckoutCity', { name: selection.name });
            } else {
                // Log failure to the console as warning
                console.warn('Geocoding via Woosmap failed.');
                $.spinner().stop();
            }
        });

        woosmapListenerForModalClose();
    }
}

const lazyValue = (fn) => {
    let called = false;
    let returnValue;

    return () => {
        if (!called) {
            called = true;
            returnValue = fn();
        }

        return returnValue;
    };
};

let googleMapsScriptIsInjected = false;

const injectGoogleMapsApiScript = (options = {}) => {
    if (googleMapsScriptIsInjected) {
        throw new Error('Google Maps Api is already loaded.');
    }

    const optionsQuery = Object.keys(options)
        .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(options[k])}`)
        .join('&');

    const url = `https://maps.googleapis.com/maps/api/js?${optionsQuery}`;

    const script = document.createElement('script');

    script.setAttribute('src', url);
    script.setAttribute('async', '');
    script.setAttribute('defer', '');

    document.head.appendChild(script);

    googleMapsScriptIsInjected = true;
};

const loadGoogleMapsApi = (apiKey, options = {}) => lazyValue(
    () => new Promise((resolve, reject) => {
        try {
            window.onGoogleMapsApiLoaded = resolve;

            injectGoogleMapsApiScript({
                key: apiKey,
                callback: 'onGoogleMapsApiLoaded',
                ...options
            });
        } catch (error) {
            reject(error);
        }
    }).then(() => window.google.maps)
);

const findinstore = new IntimissimiFindInStore();
export default findinstore;
